/*
 * MDB shim for MDBModalBody
 * Files currently importing this symbol from "mdbreact":
 * - src/Seating/Accounts/accountDetail.jsx
 * - src/Seating/Orders/ATPView.jsx
 * - src/Seating/Orders/collectionsView.jsx
 * - src/Seating/Patient/PatientViewComponents/CreateQuoteModalFromTicket.jsx
 * - src/Seating/Patient/PatientViewComponents/createNoteModal.jsx
 * - src/Seating/Patient/PatientViewComponents/notesTab.jsx
 * - src/Seating/Patient/PatientViewComponents/patientInformationTab.jsx
 * - src/Seating/Patient/PatientViewComponents/pverifyModal.jsx
 * - src/Seating/Patient/patientInformationView.jsx
 * - src/Seating/Patient/patientOrderView.jsx
 * - src/Seating/Reports/reports.jsx
 * - src/Seating/Settings/stateSalesTax.jsx
 */

import MUIDialogContent from "@mui/material/DialogContent";

export default function MDBModalBody({ children, ...rest }) {
    return <MUIDialogContent {...rest}>{children}</MUIDialogContent>;
}
